import { IPage } from '@/common/interfaces';
import { PATHS } from '@/common/path';
import {
  ContactPage,
  HomePage,
  ImpactPage,
  InstructorsPage,
  TrainingProgramsPage,
  WhoAreWePage,
  DigitalOfficePage,
  TrainingRequestPage,
  TrainingRequestsListPage,
  PlannerPage,
  TrainingProgramDetailPage,
  SignInPage,
  RequestTrainingFormPage,
  RequestTrainingFormSuccessPage,
  AnalyticsPage,
} from '../../pages';
import {
  UserProfilePage,
  UserProfileRequestList,
  UserProfileRequestDetail,
} from '../../pages/client';

export const DefaultMenuPages: Record<string, IPage> = {
  HOME: {
    component: HomePage,
    path: PATHS.home,
    slug: 'home-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Service Line Homepage', serviceSubcategory: 'Home' } },
  },
  IMPACT: {
    component: ImpactPage,
    path: PATHS.impact,
    slug: 'impact-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Service Point Selection (Map)', serviceSubcategory: 'Impact' } },
  },
  TRAININGS: {
    component: TrainingProgramsPage,
    path: PATHS.trainings,
    slug: 'trainings-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'Trainings' } },
  },
  INSTRUCTORS: {
    component: InstructorsPage,
    path: PATHS.instructors,
    slug: 'instructors-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'Instructors' } },
  },
  REQUEST_TRAINING_FORM: {
    component: RequestTrainingFormPage,
    path: PATHS.requestTraining,
    slug: 'request-training-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Service Request Form', serviceSubcategory: 'Booking form' } },
  },
  CONTACT: {
    component: ContactPage,
    path: PATHS.contact,
    slug: 'contact-page',
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'Contact' } },
  },
  PROGRAM_DETAILS: {
    component: TrainingProgramDetailPage,
    path: PATHS.trainingDetails,
    slug: 'trainings-program-detail-page',
    handle: { analytics: { pageType: 'Service Point / Itinerary detail', serviceSubcategory: 'Training program detail' } },
  },
  REQUEST_TRAINING_SUCCESS: {
    component: RequestTrainingFormSuccessPage,
    path: PATHS.requestTrainingSuccess,
    slug: 'request-training-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Service Request Form', serviceSubcategory: 'Booking form success' } },
  },
  WHO_ARE_WE: {
    component: WhoAreWePage,
    path: PATHS.whoAreWe,
    slug: 'team-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'Who are we' } },
  },
  LOGIN: {
    component: SignInPage,
    path: PATHS.login,
    slug: 'login-page',
    handle: { analytics: { pageType: 'Login', serviceSubcategory: 'Login' } },
  },
};

// If no menu is needed, can use Breadcrumbs instead
export const NoMenuPages: Record<string, IPage> = {};

export const DigitalOfficePages: Record<string, IPage> = {
  DIGITAL_OFFICE: {
    component: DigitalOfficePage,
    path: PATHS.digitalOffice,
    slug: 'digital-office-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Digital Office', serviceSubcategory: 'Digital Office overview' } },
  },
  TRAINING_REQUEST: {
    component: TrainingRequestPage,
    path: PATHS.digitalOfficeTrainingDetails,
    slug: 'digital-office-page',
    shouldLoadContent: true,
    handle: { analytics: { pageType: 'Digital Office', serviceSubcategory: 'Training request detail' } },
  },
  TRAINING_REQUEST_LIST: {
    component: TrainingRequestsListPage,
    path: PATHS.digitalOfficeTrainings,
    slug: 'training-requests',
    handle: { analytics: { pageType: 'Digital Office', serviceSubcategory: 'Training requests list' } },
  },
  PLANNER: {
    component: PlannerPage,
    path: PATHS.digitalOfficePlanner,
    slug: 'planner',
    waffleFlag: 'PLANNER_PAGE',
    handle: { analytics: { pageType: 'Digital Office', serviceSubcategory: 'Planner' } },
  },
  ANALYTICS: {
    component: AnalyticsPage,
    path: PATHS.digitalOfficeAnalytics,
    slug: 'analytics',
    waffleFlag: 'ANALYTICS_PAGE',
    handle: { analytics: { pageType: 'Digital Office', serviceSubcategory: 'Analytics' } },
  },
};

export const UserMenuPages: Record<string, IPage> = {
  PROFILE: {
    component: UserProfilePage,
    path: PATHS.userProfile,
    slug: 'user-profile',
    waffleFlag: 'USER_PROFILE_PAGE',
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'User profile' } },
  },
  PROFILE_TRAINING_REQUEST_LIST: {
    component: UserProfileRequestList,
    path: PATHS.userTrainingRequests,
    slug: 'user-profile-training-list',
    waffleFlag: 'USER_PROFILE_PAGE',
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'My training requests' } },
  },
  PROFILE_TRAINING_REQUEST_DETAIL: {
    component: UserProfileRequestDetail,
    path: PATHS.userTrainingDetails,
    slug: 'user-profile-training-detail',
    waffleFlag: 'USER_PROFILE_PAGE',
    handle: { analytics: { pageType: 'Informative Pages', serviceSubcategory: 'My training request detail' } },
  },
};

export const Pages = {
  ...DefaultMenuPages,
  ...NoMenuPages,
  ...DigitalOfficePages,
  ...UserMenuPages,
};
